import { useParams } from 'react-router-dom';
import { useTrial, useTrialLocationsList } from '@data/hooks';

export const useTrialDetails = () => {
  const { trialId = '' } = useParams<{ trialId: string }>();

  const { data: trial } = useTrial(trialId);
  const { data: trialLocations, isLoading } = useTrialLocationsList(trialId, {
    limit: 100,
    offset: 0,
  });

  return {
    trial,
    trialId,
    trialLocations,
    isTrialLocationsLoading: isLoading,
  };
};
